import { Vector3 } from "@babylonjs/core";

const deserializeVector3 = (obj) => {
    return new Vector3(obj.x, obj.y, obj.z);
};

export default deserializeVector3